import axios from "axios";

axios.defaults.baseURL = "https://erp.happenstance.com/api/v1/";
// axios.defaults.baseURL = "http://192.168.1.202:8000/api/v1/";
// axios.defaults.baseURL = "http://127.0.0.1:8000/api/v1/";

export default {
  getProfile: function () {
    return axios.get("/employee/profile");
  },
  getEmployees: function (param) {
    return axios.get("/employees", { params: param });
  },
  getProducts: function (param) {
    return axios.get("/products", { params: param });
  },
  getProductSkus: function (param) {
    return axios.get("/product/product-skus", { params: param });
  },
  getSkuDetails: function (param) {
    return axios.get("/product/sku-details", { params: param });
  },
  getShopClasses: function () {
    return axios.get('/master/shop-classes');
  },
  getShops: function (param) {
    return axios.get("/master/shops_empl_link", { params: param });
  },

  getShopDetails: function (param) {
    return axios.get("/master/shop_details", { params: param });
  },
  getSales: function (param) {
    return axios.get("/sales/emp-shop/tertiary", { params: param });
  },
  getStocks: function (param) {
    return axios.post("/products/stock", param);
  },
  getDistributors: function (param) {
    return axios.get('/master/distributors', { params: param });
  },
  getLocations: function () {
    return axios.get('/master/locations');
  },
  getGeneratedShopCode: function () {
    return axios.get('/master/shops/generate-code');
  },



  getTypeUsers: function () {
    return axios.get('/master/type-users', {
      params: {
        'type': "shops"
      }
    })
  },
  getStockReportExport: function (param) {
    return axios.get("/products/stock/export", {
      params: param,
      responseType: "blob",
      headers: {
        Accept: "application/xlsx",
      },
    });
  },
  getSalesexport: function (param) {
    return axios.get("/sales/emp-shop/export", {
      params: param,
      responseType: "blob",
      headers: {
        Accept: "application/xlsx",
      },
    });
  },

  saveShop: function (shop) {
    return axios.post('/master/shop/save', shop);
  },


  //Locations
  getCountries: function () {
    return axios.get('/master/location/countries'); // All Countries
  },
  getChildLocations: function (param) {
    return axios.get('/master/locations/child', { params: param })
  },
  getCountriesWithChild: function () {
    return axios.get('/master/location/countries/all');
  },
  saveLocation: function (location) {
    return axios.post('/master/location/save', location);
  },
  saveUser: function (user) {
    return axios.post('/user/save', user, {
      params: {
        'type': "shops"
      }
    })
  },

  //Image slider
  getSlider: function (param) {
    return axios.get('/slider/get-slider', { params: param });
  },

};
